var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("商品管理")]),
              _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: {
                      name: "servingManagement",
                      query: { dateId: _vm.listParams.dateId },
                    },
                  },
                },
                [_vm._v("上菜管理")]
              ),
              _c("el-breadcrumb-item", [_vm._v("调整数据")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.listParams, "label-width": "100px" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "基地名称：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                size: "small",
                                placeholder: "请选择基地名称",
                              },
                              model: {
                                value: _vm.listParams.farmId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listParams, "farmId", $$v)
                                },
                                expression: "listParams.farmId",
                              },
                            },
                            _vm._l(_vm.baseNameList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.title, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.loadColumnTitle },
                            },
                            [_vm._v(" 查询 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: {
            "show-pager-on-one-page": false,
            "page-info": _vm.pager,
            loading: _vm.tableLoading,
          },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "mgl20",
                    staticStyle: {
                      "line-height": "30px",
                      "font-weight": "500",
                    },
                  },
                  [
                    _c("span", [_vm._v("领货日期：")]),
                    _vm.deliveryTakenDate
                      ? _c("span", { staticClass: "alert-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatDate")(_vm.deliveryTakenDate, true)
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  { staticStyle: { position: "absolute", right: "0" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.resetTableData },
                      },
                      [_vm._v(" 重置 ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: _vm.isDisabled,
                          type: "success",
                          size: "small",
                        },
                        on: { click: _vm.saveEdit },
                      },
                      [_vm._v(" 保存修改 ")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "goodsId",
                  align: "center",
                  fixed: "",
                  label: "序号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "title",
                  align: "center",
                  fixed: "",
                  label: "产品名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "spec",
                  align: "center",
                  fixed: "",
                  label: "规格",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "stockTotal",
                  align: "center",
                  label: "基地供应能力",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "little", align: "center", label: "富余量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { size: "small" },
                          on: {
                            change: function ($event) {
                              return _vm.reset($event, scope.$index)
                            },
                          },
                          model: {
                            value: scope.row.little,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "little", $$v)
                            },
                            expression: "scope.row.little",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._l(_vm.columnList, function (item, index) {
                return _c("el-table-column", {
                  key: index,
                  attrs: { align: "center", label: item.logisticName },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.showSuplly(
                              _vm.columnList[index].plaLogisticSiteId,
                              scope.row.stockProportionList,
                              index,
                              scope.$index
                            )
                              ? _c("el-input", {
                                  attrs: { size: "small" },
                                  model: {
                                    value: scope.row.list[index],
                                    callback: function ($$v) {
                                      _vm.$set(scope.row.list, index, $$v)
                                    },
                                    expression: "scope.row.list[index]",
                                  },
                                })
                              : _c("span", [_vm._v("0")]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }